import { useEffect } from "react";
import { MapPin, MessageCircle, Phone, Store, X } from "lucide-react";
import { API_BASE } from "../lib/api";

export default function BranchPopup({ b, onClose }) {
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    document.body.style.overflow = b ? "hidden" : "";
    return () => { window.removeEventListener("keydown", esc); document.body.style.overflow = ""; };
  }, [b, onClose]);

  if (!b) return null;
  const wa = `https://wa.me/91${b.phone}?text=${encodeURIComponent(`Namaste! I found your INDIAFAST branch "${b.shop_name}" on the website. I want to ship a parcel.`)}`;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-navy/70 p-0 backdrop-blur-sm sm:items-center sm:p-6"
         onClick={onClose} data-testid="branch-popup">
      <div className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-t-3xl bg-white shadow-2xl sm:rounded-3xl"
           onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="relative h-52 overflow-hidden bg-navy sm:h-60">
          {b.photo_path ? (
            <img src={`${API_BASE}/api/branches/public/photo/${b.id}`} alt={b.shop_name} className="h-full w-full object-cover" />
          ) : (
            <div className="grid h-full place-items-center"><Store className="h-14 w-14 text-white/30" /></div>
          )}
          <span className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-saffron via-white to-emerald-600" />
          <button onClick={onClose} data-testid="branch-popup-close" aria-label="Close"
                  className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-navy/80 text-white backdrop-blur transition-colors hover:bg-saffron">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-saffron">INDIAFAST Branch</p>
          <h3 className="mt-1 font-heading text-xl font-extrabold text-navy" data-testid="branch-popup-name">{b.shop_name}</h3>
          <p className="mt-0.5 text-sm font-semibold text-slate-500">Managed by {b.agent_name}</p>

          <div className="mt-4 flex flex-wrap gap-2" data-testid="branch-popup-location">
            {[b.city, b.district, b.state, b.pincode].filter(Boolean).map((t, i) => (
              <span key={i} className={`rounded-full px-3 py-1 text-[11px] font-bold ${i === 3 ? "bg-saffron/10 text-saffron" : "bg-slate-100 text-slate-600"}`}>
                {i === 3 ? `PIN ${t}` : t}
              </span>
            ))}
          </div>

          <div className="mt-4 flex gap-3 rounded-xl bg-slate-50 p-4">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-saffron" />
            <p className="text-sm leading-relaxed text-slate-600" data-testid="branch-popup-address">
              {b.address}{b.pincode ? `, ${b.city} - ${b.pincode}` : ""}
            </p>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-3">
            <a href={`tel:+91${b.phone}`} data-testid="branch-popup-call"
               className="flex items-center justify-center gap-2 rounded-xl bg-navy px-3 py-3 text-xs font-bold text-white transition-colors hover:bg-express">
              <Phone className="h-4 w-4" /> Call
            </a>
            <a href={wa} target="_blank" rel="noreferrer" data-testid="branch-popup-whatsapp"
               className="flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-3 py-3 text-xs font-bold text-white transition-colors hover:bg-emerald-500">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
            {b.lat != null && b.lng != null && (
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${b.lat},${b.lng}`} target="_blank" rel="noreferrer" data-testid="branch-popup-directions"
                 className="col-span-2 flex items-center justify-center gap-2 rounded-xl border border-saffron/40 bg-saffron/10 px-3 py-3 text-xs font-bold text-saffron transition-colors hover:bg-saffron/20 sm:col-span-1">
                <MapPin className="h-4 w-4" /> Directions
              </a>
            )}
          </div>
          <p className="mt-4 text-center text-[11px] text-slate-400">Branch phone: +91 {b.phone}</p>
        </div>
      </div>
    </div>
  );
}
